/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUsuario = /* GraphQL */ `
  query GetUsuario($id: ID!) {
    getUsuario(id: $id) {
      id
      name
      email
      proyectos {
        nextToken
        __typename
      }
      institucion {
        id
        name
        tipo
        createdAt
        updatedAt
        __typename
      }
      institucionId
      logs {
        nextToken
        __typename
      }
      creditos {
        id
        usuarioId
        creditosUsados
        tokensIngresados
        tokensRecibidos
        createdAt
        updatedAt
        __typename
      }
      creditosId
      perfil {
        id
        nombre
        apellido
        tel
        cargo
        RBD
        colegio
        pais
        ciudad
        usuarioId
        createdAt
        updatedAt
        __typename
      }
      perfilId
      isActive
      createdAt
      updatedAt
      institucionUsuariosId
      __typename
    }
  }
`;
export const listUsuarios = /* GraphQL */ `
  query ListUsuarios(
    $id: ID
    $filter: ModelUsuarioFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUsuarios(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const usuariosByEmail = /* GraphQL */ `
  query UsuariosByEmail(
    $email: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUsuarioFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usuariosByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const usuariosByInstitucionId = /* GraphQL */ `
  query UsuariosByInstitucionId(
    $institucionId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUsuarioFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usuariosByInstitucionId(
      institucionId: $institucionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const usuariosByCreditosId = /* GraphQL */ `
  query UsuariosByCreditosId(
    $creditosId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUsuarioFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usuariosByCreditosId(
      creditosId: $creditosId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const usuariosByPerfilId = /* GraphQL */ `
  query UsuariosByPerfilId(
    $perfilId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUsuarioFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usuariosByPerfilId(
      perfilId: $perfilId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCreditos = /* GraphQL */ `
  query GetCreditos($id: ID!) {
    getCreditos(id: $id) {
      id
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      creditosUsados
      tokensIngresados
      tokensRecibidos
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCreditos = /* GraphQL */ `
  query ListCreditos(
    $id: ID
    $filter: ModelCreditosFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCreditos(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        usuarioId
        creditosUsados
        tokensIngresados
        tokensRecibidos
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const creditosByUsuarioId = /* GraphQL */ `
  query CreditosByUsuarioId(
    $usuarioId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCreditosFilterInput
    $limit: Int
    $nextToken: String
  ) {
    creditosByUsuarioId(
      usuarioId: $usuarioId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        usuarioId
        creditosUsados
        tokensIngresados
        tokensRecibidos
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProyecto = /* GraphQL */ `
  query GetProyecto($id: ID!) {
    getProyecto(id: $id) {
      id
      name
      tipoEstructura
      nivelCurso
      asignaturas
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      resultados {
        nextToken
        __typename
      }
      institucion {
        id
        name
        tipo
        createdAt
        updatedAt
        __typename
      }
      institucionId
      projectUserInputs {
        nextToken
        __typename
      }
      organizacionId
      isCloneProject
      idProyectoFuente
      isEliminated
      createdAt
      updatedAt
      usuarioProyectosId
      institucionProyectosId
      __typename
    }
  }
`;
export const listProyectos = /* GraphQL */ `
  query ListProyectos(
    $id: ID
    $filter: ModelProyectoFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listProyectos(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        tipoEstructura
        nivelCurso
        asignaturas
        usuarioId
        institucionId
        organizacionId
        isCloneProject
        idProyectoFuente
        isEliminated
        createdAt
        updatedAt
        usuarioProyectosId
        institucionProyectosId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const proyectosByTipoEstructura = /* GraphQL */ `
  query ProyectosByTipoEstructura(
    $tipoEstructura: String!
    $sortDirection: ModelSortDirection
    $filter: ModelProyectoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    proyectosByTipoEstructura(
      tipoEstructura: $tipoEstructura
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        tipoEstructura
        nivelCurso
        asignaturas
        usuarioId
        institucionId
        organizacionId
        isCloneProject
        idProyectoFuente
        isEliminated
        createdAt
        updatedAt
        usuarioProyectosId
        institucionProyectosId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const proyectosByNivelCurso = /* GraphQL */ `
  query ProyectosByNivelCurso(
    $nivelCurso: String!
    $sortDirection: ModelSortDirection
    $filter: ModelProyectoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    proyectosByNivelCurso(
      nivelCurso: $nivelCurso
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        tipoEstructura
        nivelCurso
        asignaturas
        usuarioId
        institucionId
        organizacionId
        isCloneProject
        idProyectoFuente
        isEliminated
        createdAt
        updatedAt
        usuarioProyectosId
        institucionProyectosId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const proyectosByUsuarioId = /* GraphQL */ `
  query ProyectosByUsuarioId(
    $usuarioId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelProyectoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    proyectosByUsuarioId(
      usuarioId: $usuarioId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        tipoEstructura
        nivelCurso
        asignaturas
        usuarioId
        institucionId
        organizacionId
        isCloneProject
        idProyectoFuente
        isEliminated
        createdAt
        updatedAt
        usuarioProyectosId
        institucionProyectosId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const proyectosByInstitucionId = /* GraphQL */ `
  query ProyectosByInstitucionId(
    $institucionId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelProyectoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    proyectosByInstitucionId(
      institucionId: $institucionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        tipoEstructura
        nivelCurso
        asignaturas
        usuarioId
        institucionId
        organizacionId
        isCloneProject
        idProyectoFuente
        isEliminated
        createdAt
        updatedAt
        usuarioProyectosId
        institucionProyectosId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const proyectosByOrganizacionId = /* GraphQL */ `
  query ProyectosByOrganizacionId(
    $organizacionId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelProyectoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    proyectosByOrganizacionId(
      organizacionId: $organizacionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        tipoEstructura
        nivelCurso
        asignaturas
        usuarioId
        institucionId
        organizacionId
        isCloneProject
        idProyectoFuente
        isEliminated
        createdAt
        updatedAt
        usuarioProyectosId
        institucionProyectosId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const proyectosByIdProyectoFuente = /* GraphQL */ `
  query ProyectosByIdProyectoFuente(
    $idProyectoFuente: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelProyectoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    proyectosByIdProyectoFuente(
      idProyectoFuente: $idProyectoFuente
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        tipoEstructura
        nivelCurso
        asignaturas
        usuarioId
        institucionId
        organizacionId
        isCloneProject
        idProyectoFuente
        isEliminated
        createdAt
        updatedAt
        usuarioProyectosId
        institucionProyectosId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getResultado = /* GraphQL */ `
  query GetResultado($id: ID!) {
    getResultado(id: $id) {
      id
      etapa
      proyecto {
        id
        name
        tipoEstructura
        nivelCurso
        asignaturas
        usuarioId
        institucionId
        organizacionId
        isCloneProject
        idProyectoFuente
        isEliminated
        createdAt
        updatedAt
        usuarioProyectosId
        institucionProyectosId
        __typename
      }
      proyectoId
      resultado
      promptLLM
      in_tokens
      out_tokens
      calificacion
      createdAt
      updatedAt
      proyectoResultadosId
      __typename
    }
  }
`;
export const listResultados = /* GraphQL */ `
  query ListResultados(
    $id: ID
    $filter: ModelResultadoFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listResultados(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        etapa
        proyectoId
        resultado
        promptLLM
        in_tokens
        out_tokens
        calificacion
        createdAt
        updatedAt
        proyectoResultadosId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const resultadosByProyectoId = /* GraphQL */ `
  query ResultadosByProyectoId(
    $proyectoId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelResultadoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    resultadosByProyectoId(
      proyectoId: $proyectoId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        etapa
        proyectoId
        resultado
        promptLLM
        in_tokens
        out_tokens
        calificacion
        createdAt
        updatedAt
        proyectoResultadosId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProjectUserInput = /* GraphQL */ `
  query GetProjectUserInput($id: ID!) {
    getProjectUserInput(id: $id) {
      id
      etapa
      proyecto {
        id
        name
        tipoEstructura
        nivelCurso
        asignaturas
        usuarioId
        institucionId
        organizacionId
        isCloneProject
        idProyectoFuente
        isEliminated
        createdAt
        updatedAt
        usuarioProyectosId
        institucionProyectosId
        __typename
      }
      proyectoId
      input
      createdAt
      updatedAt
      proyectoProjectUserInputsId
      __typename
    }
  }
`;
export const listProjectUserInputs = /* GraphQL */ `
  query ListProjectUserInputs(
    $id: ID
    $filter: ModelProjectUserInputFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listProjectUserInputs(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        etapa
        proyectoId
        input
        createdAt
        updatedAt
        proyectoProjectUserInputsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const projectUserInputsByProyectoId = /* GraphQL */ `
  query ProjectUserInputsByProyectoId(
    $proyectoId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelProjectUserInputFilterInput
    $limit: Int
    $nextToken: String
  ) {
    projectUserInputsByProyectoId(
      proyectoId: $proyectoId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        etapa
        proyectoId
        input
        createdAt
        updatedAt
        proyectoProjectUserInputsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLog = /* GraphQL */ `
  query GetLog($id: ID!) {
    getLog(id: $id) {
      id
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      detail
      action
      createdAt
      updatedAt
      usuarioLogsId
      __typename
    }
  }
`;
export const listLogs = /* GraphQL */ `
  query ListLogs(
    $id: ID
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLogs(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        usuarioId
        detail
        action
        createdAt
        updatedAt
        usuarioLogsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const logsByUsuarioId = /* GraphQL */ `
  query LogsByUsuarioId(
    $usuarioId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    logsByUsuarioId(
      usuarioId: $usuarioId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        usuarioId
        detail
        action
        createdAt
        updatedAt
        usuarioLogsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const logsByDetail = /* GraphQL */ `
  query LogsByDetail(
    $detail: String!
    $sortDirection: ModelSortDirection
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    logsByDetail(
      detail: $detail
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        usuarioId
        detail
        action
        createdAt
        updatedAt
        usuarioLogsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const logsByAction = /* GraphQL */ `
  query LogsByAction(
    $action: String!
    $sortDirection: ModelSortDirection
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    logsByAction(
      action: $action
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        usuarioId
        detail
        action
        createdAt
        updatedAt
        usuarioLogsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInstitucion = /* GraphQL */ `
  query GetInstitucion($id: ID!) {
    getInstitucion(id: $id) {
      id
      name
      tipo
      usuarios {
        nextToken
        __typename
      }
      proyectos {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listInstitucions = /* GraphQL */ `
  query ListInstitucions(
    $id: ID
    $filter: ModelInstitucionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listInstitucions(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        tipo
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const institucionsByName = /* GraphQL */ `
  query InstitucionsByName(
    $name: String!
    $sortDirection: ModelSortDirection
    $filter: ModelInstitucionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    institucionsByName(
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        tipo
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const institucionsByTipo = /* GraphQL */ `
  query InstitucionsByTipo(
    $tipo: String!
    $sortDirection: ModelSortDirection
    $filter: ModelInstitucionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    institucionsByTipo(
      tipo: $tipo
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        tipo
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getWhitelistUser = /* GraphQL */ `
  query GetWhitelistUser($id: ID!) {
    getWhitelistUser(id: $id) {
      id
      email
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listWhitelistUsers = /* GraphQL */ `
  query ListWhitelistUsers(
    $filter: ModelWhitelistUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWhitelistUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPerfil = /* GraphQL */ `
  query GetPerfil($id: ID!) {
    getPerfil(id: $id) {
      id
      nombre
      apellido
      tel
      cargo
      RBD
      colegio
      pais
      ciudad
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPerfils = /* GraphQL */ `
  query ListPerfils(
    $id: ID
    $filter: ModelPerfilFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPerfils(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        nombre
        apellido
        tel
        cargo
        RBD
        colegio
        pais
        ciudad
        usuarioId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const perfilsByRBD = /* GraphQL */ `
  query PerfilsByRBD(
    $RBD: String!
    $sortDirection: ModelSortDirection
    $filter: ModelPerfilFilterInput
    $limit: Int
    $nextToken: String
  ) {
    perfilsByRBD(
      RBD: $RBD
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        nombre
        apellido
        tel
        cargo
        RBD
        colegio
        pais
        ciudad
        usuarioId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const perfilsByColegio = /* GraphQL */ `
  query PerfilsByColegio(
    $colegio: String!
    $sortDirection: ModelSortDirection
    $filter: ModelPerfilFilterInput
    $limit: Int
    $nextToken: String
  ) {
    perfilsByColegio(
      colegio: $colegio
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        nombre
        apellido
        tel
        cargo
        RBD
        colegio
        pais
        ciudad
        usuarioId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const perfilsByUsuarioId = /* GraphQL */ `
  query PerfilsByUsuarioId(
    $usuarioId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelPerfilFilterInput
    $limit: Int
    $nextToken: String
  ) {
    perfilsByUsuarioId(
      usuarioId: $usuarioId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        nombre
        apellido
        tel
        cargo
        RBD
        colegio
        pais
        ciudad
        usuarioId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getChatAgentSession = /* GraphQL */ `
  query GetChatAgentSession($id: ID!) {
    getChatAgentSession(id: $id) {
      id
      userId
      sessionName
      proyectoId
      resultadoId
      modelName
      modelId
      totalTokens
      creditosDescontados
      conversionFactor
      conversionUnit
      mensajes {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listChatAgentSessions = /* GraphQL */ `
  query ListChatAgentSessions(
    $id: ID
    $filter: ModelChatAgentSessionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listChatAgentSessions(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userId
        sessionName
        proyectoId
        resultadoId
        modelName
        modelId
        totalTokens
        creditosDescontados
        conversionFactor
        conversionUnit
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const chatAgentSessionsByUserId = /* GraphQL */ `
  query ChatAgentSessionsByUserId(
    $userId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelChatAgentSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    chatAgentSessionsByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        sessionName
        proyectoId
        resultadoId
        modelName
        modelId
        totalTokens
        creditosDescontados
        conversionFactor
        conversionUnit
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const chatAgentSessionsByProyectoId = /* GraphQL */ `
  query ChatAgentSessionsByProyectoId(
    $proyectoId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelChatAgentSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    chatAgentSessionsByProyectoId(
      proyectoId: $proyectoId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        sessionName
        proyectoId
        resultadoId
        modelName
        modelId
        totalTokens
        creditosDescontados
        conversionFactor
        conversionUnit
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const chatAgentSessionsByResultadoId = /* GraphQL */ `
  query ChatAgentSessionsByResultadoId(
    $resultadoId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelChatAgentSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    chatAgentSessionsByResultadoId(
      resultadoId: $resultadoId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        sessionName
        proyectoId
        resultadoId
        modelName
        modelId
        totalTokens
        creditosDescontados
        conversionFactor
        conversionUnit
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const chatAgentSessionsByModelName = /* GraphQL */ `
  query ChatAgentSessionsByModelName(
    $modelName: String!
    $sortDirection: ModelSortDirection
    $filter: ModelChatAgentSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    chatAgentSessionsByModelName(
      modelName: $modelName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        sessionName
        proyectoId
        resultadoId
        modelName
        modelId
        totalTokens
        creditosDescontados
        conversionFactor
        conversionUnit
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const chatAgentSessionsByModelId = /* GraphQL */ `
  query ChatAgentSessionsByModelId(
    $modelId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelChatAgentSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    chatAgentSessionsByModelId(
      modelId: $modelId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        sessionName
        proyectoId
        resultadoId
        modelName
        modelId
        totalTokens
        creditosDescontados
        conversionFactor
        conversionUnit
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getChatAgentMessage = /* GraphQL */ `
  query GetChatAgentMessage($id: ID!) {
    getChatAgentMessage(id: $id) {
      id
      chatSessionId
      actor
      instruction
      content
      tokensUsed
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listChatAgentMessages = /* GraphQL */ `
  query ListChatAgentMessages(
    $id: ID
    $filter: ModelChatAgentMessageFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listChatAgentMessages(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        chatSessionId
        actor
        instruction
        content
        tokensUsed
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const chatAgentMessagesByChatSessionId = /* GraphQL */ `
  query ChatAgentMessagesByChatSessionId(
    $chatSessionId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelChatAgentMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    chatAgentMessagesByChatSessionId(
      chatSessionId: $chatSessionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        chatSessionId
        actor
        instruction
        content
        tokensUsed
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const chatAgentMessagesByActor = /* GraphQL */ `
  query ChatAgentMessagesByActor(
    $actor: String!
    $sortDirection: ModelSortDirection
    $filter: ModelChatAgentMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    chatAgentMessagesByActor(
      actor: $actor
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        chatSessionId
        actor
        instruction
        content
        tokensUsed
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
